
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Entry point: render <App /> inside root div
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
